import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  legacyTitle: {
    id: 'catalog.home-page.title',
    defaultMessage: 'Welcome to {siteName}',
    description: 'Legacy main heading text kept for backward compatibility in tests and legacy slots.',
  },
  legacySubtitle: {
    id: 'catalog.home-page.subtitle',
    defaultMessage: 'The platform is running. Powered by Open edX®',
    description: 'Legacy secondary text kept for backward compatibility in tests and legacy slots.',
  },
  subtitle: {
    id: 'catalog.home-page.subtitle.compat',
    defaultMessage: 'The platform is running. Powered by Open edX®',
    description: 'Compatibility subtitle message for legacy tests and slots.',
  },
  searchPlaceholder: {
    id: 'catalog.home-page.search-placeholder',
    defaultMessage: 'Search for a course',
    description: 'Legacy search placeholder kept for backward compatibility in tests and legacy slots.',
  },
  eyebrow: {
    id: 'catalog.home-page.hero.eyebrow',
    defaultMessage: 'Welcome to WutiSkill',
    description: 'Eyebrow label displayed above the home page hero title.',
  },
  title: {
    id: 'catalog.home-page.hero.title',
    defaultMessage: 'Take your career to the <highlight>next level</highlight>',
    description: 'Main heading text displayed in the public catalog hero.',
  },
  description: {
    id: 'catalog.home-page.hero.description',
    defaultMessage: 'Unlock your potential with our complete learning platform. Master new skills, advance your career, and join thousands of successful learners.',
    description: 'Secondary text displayed below the hero title on the home page.',
  },
  primaryCta: {
    id: 'catalog.home-page.hero.primary-cta',
    defaultMessage: 'Start learning',
    description: 'Primary CTA label in the home page hero.',
  },
  videoButton: {
    id: 'catalog.home-page.video-button',
    defaultMessage: 'View presentation video',
    description: 'Legacy label for the promo video button.',
  },
  videoButtonAlt: {
    id: 'catalog.home-page.video-button-alt',
    defaultMessage: 'open presentation video',
    description: 'Alternative text for the promo video button.',
  },
  secondaryCta: {
    id: 'catalog.home-page.hero.secondary-cta',
    defaultMessage: 'Browse courses',
    description: 'Secondary CTA label in the home page hero.',
  },
  illustrationAlt: {
    id: 'catalog.home-page.hero.illustration-alt',
    defaultMessage: 'Illustration of a learner in front of a computer',
    description: 'Alternative text for the hero illustration on the home page.',
  },
});

export default messages;
